<template>

    <div class="map-wrapper" :class="getClassMobile">

        <fragment>

            <MglMap
                :mapboxGl="mapboxgl"
                :data-slideID="slide.id"
                :ref="`filter-map`"
                @load="onMapLoaded"
                :accessToken="accessToken"
                :mapStyle.sync="mapStyle"
                :center="currentCenter"
                :zoom="currentZoom"
                :minZoom="5"
                :maxZoom="18"

            >
                <MglNavigationControl position="bottom-right"/>
                <!-- se-synpunkter -->

                <div v-if="currentOpinion.length">

                    <MglMarker
                        :coordinates="[ currentOpinion[0].lng, currentOpinion[0].lat ]"
                        style="opacity: 0"
                    >

                        <MglPopup
                            :ref="`infowindow`"
                            :showed="true"
                            :close-button="false"
                        >
                            <opinion @close-popup="closePopup" :currentOpinion="currentOpinion" :slide="slide" />

                        </MglPopup>

                    </MglMarker>

                </div>

            </MglMap>

        </fragment>

    </div>


</template>



<script>

import mapboxgl from 'mapbox-gl'

import mapBoxSettings from './../../../mapbox-settings'

import { MglMap, MglNavigationControl, MglGeolocateControl, MglPopup, MglMarker } from 'vue-mapbox'

import { toggleOpinionForm, getSearchParameters } from './../../../tool/functions'


import { Fragment } from 'vue-fragment'

import { infoOptions }from '../../../tool/settings'

import Opinion from './Opinion'

export default {

    mounted () {

        this.getData()

        this.onResize()

        window.addEventListener("resize", this.onResize, { passive: true })

        this.goodOptions = this.slide.question.options.filter(option => option.type === 'good').map(option  => option.id)

        this.badOptions = this.slide.question.options.filter(option => option.type === 'bad').map(option  => option.id)

    },

    data() {

        return {

            accessToken : mapBoxSettings.accessToken,

            mapStyle : mapBoxSettings.mapStyle,

            collectedAnswers : [],

            infoOptions,

            infoWindowPos : { lat : null, lng: null },

            infoWinOpen : false,

            currentOpinion : [],

            currentMapZoom : null,

            currentMapCenter : null,

            mapboxgl,

            mapbox : null,

            map : null,

            flying : false,

            goodOptions : [],

            badOptions : [],

            debounce : null,

            debounceTimer : 1000

        }

    },

    props: {

        filters : Object,

        slide : Object

    },

    watch: {

        filters(newItems, oldItems) {

            if(oldItems !== newItems) {

                clearTimeout(this.debounce)

                this.debounce = setTimeout(() => {

                    this.getData()

                }, this.debounceTimer)

                this.applyFilters()

            }

        },

    },

    components: {

        Opinion,

        Fragment,

        MglMap,

        MglNavigationControl,

        MglGeolocateControl,

        MglPopup,

        MglMarker

    },

    computed : {

        currentZoom: function() {
            return this.currentMapZoom ? this.currentMapZoom : 8
        },

        currentCenter: function() {
            return this.currentMapCenter ? [ parseFloat(this.currentMapCenter.lng), parseFloat(this.currentMapCenter.lat)  ] : [ parseFloat(this.slide.center_lng), parseFloat(this.slide.center_lat) ]
        },

        getClassMobile: function() {
            return this.onResize();
        },

    },

    methods : {

        onMapLoaded: async function(event) {

            this.mapbox = event.component.mapbox

            this.map = event.map

            this.map.on('zoomend', () => this.zoom_changed() )

            this.map.on('flystart', (marker) => {
                this.flying = marker;
            });

            this.map.on('flyend', () => {
                this.flying = false;
            });

            this.map.on('moveend', (e) => {

                if(this.flying) {

                    const marker = this.flying

                    this.currentOpinion = this.collectedAnswers && this.collectedAnswers.length && marker ? this.collectedAnswers.filter( el => el.lat == marker.lat && el.lng == marker.lng) : [marker];

                    this.map.fire('flyend');

                }

            });

            this.addIconTypes()

            .then(()=> {

                if( this.mapPathsItem().length ) {

                    this.map.addSource('polygon-source', {
                        'type': 'geojson',
                        'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Polygon',
                            'coordinates': this.mapPathsItem()
                        }
                    }});

                    this.map.addLayer({
                        'id': 'polygon-figure',
                        'type': 'fill',
                        'source': 'polygon-source',
                        'layout': {},
                        'paint': {
                            'fill-opacity': 0
                        }
                    });

                    this.map.addLayer({
                        'id': 'polygon-outline',
                        'type': 'line',
                        'source': 'polygon-source',
                        'layout': {},
                        'paint': {
                            'line-color': '#fff',
                            'line-width': 3
                        }
                    });

                }

                if( this.addOpinion ) {
                    this.map.on('click', (e) => this.addMarker(e) )
                } else {
                    this.addSource(event)
                }

            });

            window.addEventListener('resize', () => {
                this.map.resize()
            })

        },

        zoom_changed: function(e){

            if( this.$refs[`filter-map`] !== undefined ) {

                this.currentMapZoom = this.map.getZoom()

                this.currentMapCenter = this.map.getCenter();

            }

        },

        toggleOpinion: function(marker) {
            return toggleOpinionForm(marker);
        },

        mapPathsItem: function() {

            if( this.slide.item_paths.length ) {

                let paths = this.slide.item_paths.map(val => ( [parseFloat(val.lng), parseFloat(val.lat) ] ))

                if( paths[0] !== paths[paths.length - 1] ) {
                    paths.push(paths[0])
                }

                paths = [ paths ];

                return paths
            }

            return [];
        },

        // enitted event from formPopup and currentOpinionWindow to handle remove popup from mapbox
        closePopup: function() {
            this.currentOpinion = []
        },

        addSource: function(e) {

            const deeplink = getSearchParameters() ? '/' + getSearchParameters().deeplink : ''

            const data = '/api/item/geojson/' + this.slide.id + deeplink

            this.map.addSource('places', {
                type: 'geojson',
                tolerance: 0,
                data: data
            });

            this.map.fitBounds( this.getBounds(), { padding: 32, duration: 0 } )

            this.addLayerPlaces()

            this.map.on('click', 'places', (e) => {

                const markerID = e.features[0].properties.marker

                const marker = this.collectedAnswers.find( answer => answer.id === markerID)

                this.map.flyTo({
                    center : [ parseFloat(marker.lng), parseFloat(marker.lat) ],
                    essential: true
                })

                this.map.fire('flystart', marker);

            })

            this.map.on('mouseenter', 'places', () => {
                this.map.getCanvas().style.cursor = 'pointer';
            })


            this.map.on('mouseleave', 'places', () => {
                this.map.getCanvas().style.cursor = '';
            })

        },

        addLayerPlaces: function() {

            this.map.addLayer({
                id : 'places',
                type : 'symbol',
                source : 'places',
                layout : {
                    'icon-image': ['get', 'icon'],
                    'icon-allow-overlap': true,
                    "text-allow-overlap": true,
                },

                paint : {
                    'icon-opacity': 1
                }
            })

        },

        addIconTypes: function() {

            return new Promise((resolve, reject) => {

                const types = ['pin_bra', 'pin_forbattra', 'deeplink']

                types.forEach(imageName => {

                    this.map.loadImage(`/images/${imageName}.png`, (error, image) => {

                        if (error) throw error

                        this.map.addImage(imageName, image)

                    })

                })

                resolve()

            })

        },

        getBounds: function() {

            const paths = this.mapPathsItem()

            if( ! paths.length) return []

            const fit = L.polygon(paths[0]).getBounds();

            const southWest = [fit['_southWest']['lat'], fit['_southWest']['lng']];

            const northEast = [fit['_northEast']['lat'], fit['_northEast']['lng']];

            return [ southWest , northEast ]

        },

        applyFilters: function(values) {

            const filters = this.mapBoxFilter( this.goodOptions, this.badOptions )

            this.map.setFilter( 'places', filters )
        },

        getData: function() {

            axios.post(`/api/get-filtered-map`, { filters: this.filters })

            .then((res) => {
                this.collectedAnswers = res.data
            })

            .catch((err) => {
                console.error(err);
            })

        },

        onResize: function() {
            return window.innerWidth > 600 ? 'is-not-mobile' : 'is-mobile'
        },

        mapBoxFilter: function( incomingGoodOptions, incomingBadOptions ) {

            const goodToggle = this.filters.goodbad.includes('good') ? true : false

            const badToggle = this.filters.goodbad.includes('bad') ? true : false

            const ages = this.filters.ages

            const genders = this.filters.genders

            const types = this.filters.types

            const counties = this.filters.counties

            const qualities = this.filters.good_types.map(val => val.id).concat(this.filters.bad_types.map(val => val.id))

            let filters = ['all']

            let agesArray = [], gendersArray = [], typesArray = [], countyArray = [], goodBadArray = [], goodArray = [], badArray = []

            for (const item of ages) {
                agesArray.push(['==', 'age', item])
            }

            if( agesArray.length ) {
                filters.push(['any'].concat(agesArray))
            }

            for (const item of genders) {
                gendersArray.push(['==', 'sex', item])
            }

            if( gendersArray.length ) {
                filters.push(['any'].concat(gendersArray))
            }

            for (const item of types) {
                typesArray.push(['==', 'type', item])
            }

            if( typesArray.length ) {
                filters.push(['any'].concat(typesArray))
            }

            for (const item of counties) {
                countyArray.push(['==', 'county', item])
            }

            if( countyArray.length ) {
                filters.push(['any'].concat(countyArray))
            }

            let showGoodSub = false, showBadSub = false, showGood = false, showBad = false, showAll = false

            let goodBadFilters = []

            if( qualities.length ) {

                for (const item of qualities) {

                    if( incomingGoodOptions.includes( item ) ) {
                        goodArray.push( item )
                    }

                    if( incomingBadOptions.includes( item ) ) {
                        badArray.push( item )
                    }

                }

            }

            if( ( ! goodToggle && ! badToggle && goodArray.length && ! badArray.length  ) ) {
                // visa bara bra undernivå
                // console.log('visa bara BRA undernivå')
                showGoodSub = true
            }

            else if( ( ! goodToggle && ! badToggle && ! goodArray.length && badArray.length  ) ) {
                // visa bara bra undernivå
                // console.log('visa bara DÅLIG undernivå')
                showBadSub = true
            }

            else if( ( goodToggle && ! badToggle && ( goodArray.length || badArray.length  ) ) ) {
                // visa bara bra undernivå
                // console.log('visa bara BRA undernivå')
                showGoodSub = true
            }

            else if( ( badToggle && ! goodToggle && ( goodArray.length || badArray.length ) ) ) {
                // visa bara dåliga undernivå
                // console.log('visa bara DÅLIG undernivå')
                showBadSub = true
            }

            else if( ( goodToggle && goodArray.length && ! badArray.length ) ) {
                // bra + undervariant visa bara undervariant
                // console.log('visa bara BRA undernivå')
                showGoodSub = true
            }

            else if( ( badToggle && ! goodArray.length && badArray.length ) ) {
                // dålig + undervariant visa bara undervariant
                // console.log('visa bara DÅLIG undernivå')
                showBadSub = true
            }

            else if( ( goodToggle && ! badToggle ) && ! goodArray.length && ! badArray.length ) {
                //visa bara bra
                // console.log('visa alla BRA')
                showGood = true
            }

            else if( ( badToggle && ! goodToggle ) && ! goodArray.length && ! badArray.length ) {
                //visa bara dåliga
                // console.log('visa alla DÅLIG')
                showBad = true
            }

            else if( goodToggle && badToggle && goodArray.length && badArray.length ) {
                // console.log('visa BRA undernivå & visa DÅLIG undernivå')
                showGoodSub = true
                showBadSub = true
            }

            else if( goodArray.length && badArray.length ) {
                // console.log('visa BRA undernivå & visa DÅLIG undernivå')
                showGoodSub = true
                showBadSub = true
            }

            else {
                if( ! showGood && ! showBad && ! showGoodSub && ! showBadSub ) {
                    // console.log('visa alla')
                    showAll = true
                }
            }

            if( qualities.length ) {

                // console.log('incomingGoodOptions',incomingGoodOptions)

                for (const item of qualities) {

                    // console.log('item',item)

                    if( incomingGoodOptions.includes( item ) && showGoodSub ) {
                        goodBadFilters.push( ['==', 'good_option_' + item, true] )
                    }

                    if( incomingBadOptions.includes( item ) && showBadSub ) {
                        goodBadFilters.push( ['==', 'bad_option_' + item, true] )
                    }

                }

            }

            // console.log('qualities', qualities)


            // console.log('goodBadFilters', goodBadFilters)

            // console.log('showGood', showGood)
            // console.log('showBad', showBad)
            // console.log('showAll', showAll)


            if( showGood && ! showBad && ! showAll ) {
                // for ( const id of incomingGoodOptions ) {
                //     goodBadFilters.push( ['==', 'good_option_' + id, true] )
                // }
                goodBadFilters.push( ['==', 'value_type', 'good'] )
            }

            if( showBad && ! showGood && ! showAll ) {
                // for (const id of incomingBadOptions) {
                //     goodBadFilters.push( ['==', 'bad_option_' + id, true] )
                // }
                goodBadFilters.push( ['==', 'value_type', 'bad'] )
            }

            if( ! showBad && ! showGood && showAll ) {
                goodBadFilters.push( ['==', 'value_type', 'good'] )
                goodBadFilters.push( ['==', 'value_type', 'bad'] )
            }

            if( goodBadFilters.length ) {
                filters.push(['any'].concat( goodBadFilters ))
            }

            return filters


        }

    }
};

</script>

